export const saveAccessTokenInExtensionStorage = async (
    access_token: string | null = localStorage.getItem('ez_access_token')
) => {
    if (!access_token) {
        return;
    }
    window.postMessage({ type: 'SAVE_ACCESS_TOKEN', access_token });
};
